import { useLocation } from 'react-router-dom';

export const useUrlSlug = () => {
  const location = useLocation();

  return location.pathname.split('/').filter(Boolean).pop() || '';
};
